export default {
    NAME_DEFAULT : "Default",
    NAME_CUSTOM  : "Custom"
}


// WEBPACK FOOTER //
// ./src/components/common/customizationColumns/v1/constants.js